<template>
<div>
 
</div>
</template>
<script>
import replaceState from "../../util/replaceState";
import userService from "../../service/userService";
import { Indicator, Toast } from "mint-ui";
export default {
  data() {
    return {
      returnObj: null,
      url: null,
      i:null,
    };
  },
  mounted() {
    Indicator.open('加载中...')
    this.returnObj = replaceState.UrlSearch();
    if (this.returnObj.pageurl) {
      this.i=this.returnObj.pageurl.replace(/\-\-\-/g, "/")
      this.url = `/${this.i}`;
    } else {
      this.url = "/home";
    }
    let ReUrl =this.url;
    userService.prototype.lognOut().then(res => {
      Indicator.close()
      this.$router.push({path:'/user',
      query:{
        ReUrl:ReUrl,
        RegType:2
      }})
    }).catch(err=>[
      Indicator.close()
    ]);
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/login/loginIndex.vue